import axios from 'axios'
import { ENDPOINTS } from 'src/constants/endpoints'

import type { IUserInfoDTO } from 'src/app/auth/domain/contracts/user-info'
import { http } from 'src/interfaces/http'

export type GetUserInfoResult =
  | { status: 'ok'; data: IUserInfoDTO }
  | { status: 'forbidden' }

export interface IGetUserInfoParams {
  uuid: string
}

export const getUserInfo = async (
  params: IGetUserInfoParams,
): Promise<GetUserInfoResult> => {
  try {
    const { data } = await http.get<IUserInfoDTO>(
      ENDPOINTS.auth.userInfo(params.uuid),
    )
    return { status: 'ok', data }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status
      if (status === 403 || status === 404) {
        return { status: 'forbidden' }
      }
    }
    throw error
  }
}
